module.exports = __webpack_public_path__ + "img/person-transparent.f65fd56a.png";